import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';

//import extenso from 'extenso';
import { flatMap, get, size } from 'lodash';
import moment from 'moment';

import BoletoForm from 'components/BoletoForm';
import ErrorMessages from 'components/ErrorMessages';
import Loader from 'components/Loader';

import actions from 'containers/Form/actions';
import { EXTENSAO_DOC_ESPECIFICO_BOLETO_VD, EXTENSAO_DOC_ESPECIFICO_VD } from 'containers/Form/Detalhe';

import useMessages from 'custom-hooks/useMessages';
import useMutableState from 'custom-hooks/useMutableState';

import { sendApi } from 'utils/injectApi';

import './index.scss';

export const DOCUMENTO_TAXA_VEICULO_DIVULGACAO = 'taxa-veiculo-divulgacao';
export const RECIBO_PAGAMENTO_BOLETO_VEICULO_DIVULGACAO = 'recibo-pagamento-boleto-veiculo-divulgacao';
export const TAXA_FUNPROAMB_TLA = 6121100411;

function DocumentoVeiculoDivulgacaoBoleto({ setShowFormulario, setShowConfirm }) {
	// #region hooks
	/* REDUX */
	const dispatch = useDispatch();

	/* CUSTOM HOOKS */
	const formulario = useMutableState(['licenciamento', 'formulario']);
	const [errors, setErrors] = useState({});
	const [hasErrors, setHasErrors] = useState(false);
	const { createMessage } = useMessages();

	/* ESTADOS */
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const formRef = useRef();
	const [forceSave, setForceSave] = useState(false);

	const docEspecificoBoleto = useMemo(() => obtemVDBoletoDocumento(formulario), [formulario]);
	const docEspecificoVd = useMemo(() => obtemVDBoletoDocumento(formulario, EXTENSAO_DOC_ESPECIFICO_VD), [formulario]);
	const docEspecificoVdDados = useMemo(
		() => obtemVeiculoDivulgacaoDadosBoleto(formulario, EXTENSAO_DOC_ESPECIFICO_VD),
		[formulario]
	);
	const docEspecificoVdGerado = useMemo(() => docEspecificoVd && size(docEspecificoVd.filename) > 0, [docEspecificoVd]);
	const docEspecificoBoletoGerado = useMemo(
		() => docEspecificoBoleto && size(docEspecificoBoleto.filename) > 0,
		[docEspecificoBoleto]
	);

	// atualiza data se mudar o formulário
	useEffect(() => {
		if (!data && formulario) {
			const dd = obtemVeiculoDivulgacaoDadosBoleto(formulario);
			if (dd && size(dd.dados) > 0) {
				delete dd.dados.boleto.valor;
				setData({ ...dd.dados });
			} else {
				setData({
					boleto: {
						valor: '',
						dataVencimento: moment().add(30, 'day').format('DDMMYYYY')
					}
				});
			}
		}
	}, [data, docEspecificoVd, docEspecificoVdDados, formulario]);

	// atualiza dados se mudar o VALOR da TAXA do formulário VD
	useEffect(() => {
		if (
			docEspecificoVdDados &&
			size(docEspecificoVdDados?.dados) > 0 &&
			data?.boleto &&
			size(get(docEspecificoVdDados, 'dados.valor-taxa.value', '')) > 0 &&
			(data?.boleto.valor !== get(docEspecificoVdDados, 'dados.valor-taxa.value', '') || !data?.boleto.valor) &&
			formulario
		) {
			setData(oldState => {
				const newState = {
					...oldState,
					boleto: {
						...oldState.boleto,
						valor: get(docEspecificoVdDados, 'dados.valor-taxa.value', ''),
						dataVencimento: moment().add(30, 'day').format('DDMMYYYY')
					}
				};
				return newState;
			});
		}
	}, [data, docEspecificoVd, docEspecificoVdDados, formulario]);

	useEffect(() => {
		let checkSize = size(errors) === 1;
		// condicional para caso seja erro de geração do doc específico CS (faltou apenas gerá-lo)
		let findDoc = formulario?.documentos?.find(d => d.idDocumento === EXTENSAO_DOC_ESPECIFICO_BOLETO_VD);
		setHasErrors(!((checkSize && findDoc !== undefined && size(errors[findDoc.id]) > 0) || size(errors) === 0));
	}, [errors, formulario]);

	const salvar = useCallback(
		({ draft, errors, saveOnly, bol, gerarBoleto }) => {
			try {
				const execute = async data => {
					setLoading(true);
					const formId = get(formulario, 'formData.id');
					const url = `processo/${formId}/${EXTENSAO_DOC_ESPECIFICO_BOLETO_VD}${draft ? '?draft=true' : ''}`;
					const newData = { ...data };
					const { data: dataResponse } = await sendApi({ url, payload: { form: newData, observacoes: errors } }, false);
					return dataResponse;
				};

				let newData = { ...data, boleto: bol, gerarBoleto, draft };

				execute(newData).then(dataResponse => {
					dispatch(
						actions.alteraStatusDocumento({
							documento: dataResponse.documento,
							documentoDados: dataResponse.documentoDados
						})
					);
					if (get(dataResponse, 'erro')) {
						createMessage(
							`Não foi possível gerar o boleto${draft ? ' como rascunho:' : ':'} ${get(dataResponse, 'erro')}`,
							30,
							'message-error'
						);
					} else {
						createMessage(`Documento salvo${draft ? ' como rascunho' : ''} com sucesso`, 5);
					}
					setLoading(false);
					if (!saveOnly) {
						setShowFormulario(false);
					}
				});
			} catch (error) {
				createMessage('Problemas no salvamento do documento... verifique a console', 30);
				console.error('erro no servidor', error);
				setLoading(false);
			}
		},
		[createMessage, data, dispatch, formulario, setShowFormulario]
	);

	const cancelSubmit = () => {
		setShowConfirm(!docEspecificoBoletoGerado ? true : false);
	};
	const submit = async dataSubmit => {
		const { draft } = dataSubmit;
		let errors = {};
		if (forceSave && draft) {
			salvar({ ...dataSubmit, errors });
		} else {
			if (size(errors) > 0) {
				setErrors(errors);
				setForceSave(true);
			} else {
				setErrors({});
				salvar({ ...dataSubmit, errors });
			}
		}
	};

	const dadosRequerimento = useMemo(
		() => ({
			nomeSacado: get(formulario, 'formData.data.nomeProprietario'),
			cpfSacado: get(formulario, 'formData.data.cpfCnpjProprietario'),
			enderecoSacado: get(formulario, 'formData.data.enderecoCdlList.0.enderecoFormatadoCurto'),
			bairroSacado:
				get(formulario, 'formData.data.enderecoCdlList.0.nomeBairro') ||
				get(formulario, 'formData.data.enderecoCdlList.0.bairro'),
			cepSacado: get(formulario, 'formData.data.enderecoCdlList.0.cep'),
			ufSacado: 'RS',
			municipioSacado: 'Porto Alegre'
		}),
		[formulario]
	);

	return (
		<>
			{loading && <Loader />}
			<div className="form-vd-boleto" ref={formRef}>
				<>
					{docEspecificoVdGerado && !docEspecificoBoletoGerado ? (
						<div className={'grupoBpmTasks form-vd-boleto-wrapper'}>
							<BoletoForm
								containerRef={null}
								boleto={data?.boleto}
								dadosRequerimento={dadosRequerimento}
								boletoGerado={false}
								slotGerado={false}
								onCancelHandler={() => cancelSubmit()}
								onSubmitHandler={(bol, gerarBoleto, validate, draft) => submit({ bol, gerarBoleto, validate, draft })}
								readOnly={false}
								dataVencimentoInicial={moment().add(30, 'day').format('DDMMYYYY')}
								vencimentoEditavel={true}
								instrucaoMaxLength={80}
								nomeTaxa={'Taxa de Licença Ambiental'}
								usuarioInterno={false}
							/>
						</div>
					) : docEspecificoBoletoGerado ? (
						<div className="alert alert-warning warning-vd-boleto">
							<i className="fa fa-wpforms form-espec-icon" aria-hidden="true" />
							<i className="fa fa-exclamation-triangle triangle-icon" aria-hidden="true" />O Boleto já foi gerado! Você
							deve apagar o boleto anterior para poder gerar um novo boleto
						</div>
					) : (
						<div className="alert alert-warning warning-vd-boleto">
							<i className="fa fa-wpforms form-espec-icon" aria-hidden="true" />
							<i className="fa fa-exclamation-triangle triangle-icon" aria-hidden="true" />É necessário gerar o
							"Formulário Específico para Veículo de Divulgação" para poder gerar o boleto.
						</div>
					)}
					{hasErrors && (
						<div className="vistoria-card erros">
							<h3 className="font-weight-bold text-danger m-3">(*) Existem erros no formulário</h3>
							{<ErrorMessages errorList={flatMap(errors, v => v)} />}
						</div>
					)}
				</>
			</div>
		</>
	);
}
DocumentoVeiculoDivulgacaoBoleto.displayName = 'DocumentoVeiculoDivulgacaoBoleto';
DocumentoVeiculoDivulgacaoBoleto.propTypes = {
	setShowFormulario: PropTypes.func,
	showFormulario: PropTypes.bool,
	setShowConfirm: PropTypes.func,
	showConfirm: PropTypes.bool,
	setPosProcessFormulario: PropTypes.func,
	posProcessFormulario: PropTypes.bool,
	usuarioInterno: PropTypes.bool,
	readOnly: PropTypes.bool,
	disabled: PropTypes.bool,
	onChangeHandler: PropTypes.func,
	removeFile: PropTypes.func
};
export default DocumentoVeiculoDivulgacaoBoleto;

export function obtemVDBoletoDocumento(formulario, tipo = EXTENSAO_DOC_ESPECIFICO_BOLETO_VD) {
	const { documentos } = formulario || {};
	const documento = (documentos || []).reduce((acc, doc) => {
		if (doc.extensao === tipo) {
			if (acc) {
				return doc.versao > acc.versao ? doc : acc;
			} else {
				return doc;
			}
		}
		return acc;
	}, null);
	return documento;
}

export function obtemVeiculoDivulgacaoDadosBoleto(formulario, tipo = EXTENSAO_DOC_ESPECIFICO_BOLETO_VD) {
	const { documentosDados } = formulario || {};
	const documento = obtemVDBoletoDocumento(formulario, tipo);
	const docDados = (documentosDados || []).find(dd => dd?.id === documento?.id || dd?.id === documento.original);
	return docDados;
}
